import { transRegion, biggerOrTo, sentimentNumber } from '../../render-helper';

export default [
  { header: 'Channel', render: 'channel_name' },
  {
    header: 'Poster',
    render: 'reviewer',
  },
  {
    header: 'Content',
    render: 'content',
  },
  { header: 'URL', render: 'content_url' },
  {
    header: 'Time(UTC+8:00)',
    render: 'comment_time',
  },
  { header: 'Language', render: 'language', renderHelper: [transRegion(3)] },
  {
    header: 'View',
    render: 'view',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Engagement',
    render: 'engagement',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Follower',
    render: 'subscribe',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Sentiment',
    render: 'sentiment_rating',
    renderHelper: [sentimentNumber],
  },
];
